export default {
    title: 'Change Account',
    text: 'By confirming this action you are leaving store management and going to the customer profile.',
    buttons: {
        close: 'Close',
        confirm: 'Confirm'
    }
}
